import Container from '@/components/layout/Container';
import ExpertReviewsSlider from './ExpertReviewsSlider';
import Link from 'next/link';

export default async function ExpertReviews({ block, position }) {
  const {
    background_color_picker: background_color,
    call_to_action: { reference: cta_reference = [], link_label: cta_label },
    heading,
    subheading,
    review: reviews,
    uid: entry_uid
  } = block.expert_reviews.reference[0];

  return (
    <section
      id={entry_uid + '_' + position}
      data-name="expert-reviews"
      className={`standard-padding text-white bg-[${background_color}]`}
    >
      <Container fullpage={true}>
        {heading && (
          <h2
            className={`h4 sm:h2 ${!subheading ? 'mb-12' : 'mb-4'} w-full px-5 text-center text-white sm:px-12`}
          >
            {heading}
          </h2>
        )}
        {subheading && (
          <h2 className={`sh8 mb-12 w-full text-center text-white`}>
            {subheading}
          </h2>
        )}
        <ExpertReviewsSlider
          componentID={entry_uid + '_' + position}
          count={reviews.length}
          reviews={reviews}
        ></ExpertReviewsSlider>
        {cta_reference.length != 0 && (
          <div className="mx-auto mt-9 text-center">
            <Link
              id={entry_uid + '_' + cta_reference[0].uid}
              href={cta_reference[0].url}
              prefetch={false}
              className="body-r sm:body-l txt-btn-secondary-white"
              title={cta_reference[0].title}
            >
              {cta_label}
            </Link>
          </div>
        )}
      </Container>
    </section>
  );
}
